const homeScreenFeatureIdEnums = new Map();

homeScreenFeatureIdEnums.set(13, 'rapid-trade');
homeScreenFeatureIdEnums.set(16, 'trades/mySauda');
homeScreenFeatureIdEnums.set(9, 'community');
homeScreenFeatureIdEnums.set(8, 'distributor');
homeScreenFeatureIdEnums.set(5, 'rake');
homeScreenFeatureIdEnums.set(3, 'bahiKhata');
homeScreenFeatureIdEnums.set(1, 'shopPromotion');
homeScreenFeatureIdEnums.set(11, 'quiz');

export default homeScreenFeatureIdEnums;
